<div
  class="bg-white"
  [ngClass]="{
    'admin desktop-wrapper': !isEmployerApp,
    'grid grid-cols-[280px_1fr] grid-rows-1 h-screen w-screen': isEmployerApp,
    '!grid-cols-[68px_1fr]': isEmployerApp && isCollapsed(),
  }">
  @if (isEmployerApp) {
    <aside id="desktop-navigation" class="h-full border-r border-gray-200">
      <hub-sidebar-navigation
        [isTabletLarge]="isTabletLarge()"></hub-sidebar-navigation>
    </aside>
  } @else {
    <div id="desktop-menu" data-atm="global-nav">
      <div class="logo">
        <img src="/assets/images/brand/snagajob-white.svg" />
      </div>
      <div class="menu-wrapper">
        @for (item of menuItems; track item) {
          @if (!item.external) {
            <a
              [class]="
                item.align && item.align == 'right'
                  ? 'menu-item right'
                  : 'menu-item'
              "
              routerLink="/{{ item.route }}"
              routerLinkActive="active"
              [attr.data-atm]="'action-link-' + item.label.toLowerCase()">
              {{ item.label }}
            </a>
          } @else {
            <a
              [class]="
                item.align && item.align == 'right'
                  ? 'menu-item right external'
                  : 'menu-item external'
              "
              (click)="navigateToExternal(item)"
              href="{{ item.route }}"
              target="_blank"
              [attr.data-atm]="'action-link-' + item.label.toLowerCase()">
              @if (item.iconSrc) {
                <img class="icon" src="{{ item.iconSrc }}" />
              }
              {{ item.label }}</a
            >
          }
        }

        @if (showAdminLogo) {
          <div class="admin-logo">
            <img src="/assets/icon/internal-view-icon.svg" />
            <span>Internal</span>
          </div>
        }
      </div>
    </div>
  }

  <div
    id="desktop-content"
    [class.overflow-auto]="isEmployerApp"
    [class.scrollbar]="isEmployerApp && !isDrawerOpened()">
    <ng-content></ng-content>
  </div>
</div>
